export default __webpack_public_path__ + "static/media/air-main-meter-icon.9d1dcb7d.svg";